import React, { Component } from 'react';
import {connect} from "react-redux";
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap";
import update from 'immutability-helper';
import {firestore, getBasePath} from "../firebase";
import Loading from "../components/Loading";


class FeedbackPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            sent: false,
            form: {
                email: props.user.email || "",
                message: "",
            }
        }
    }

    handleChange(event) {
        this.setState(update(this.state, {
            form: {
                [event.target.name]: {$set: event.target.value}
            }
        }));
    }

    async submitForm(event) {
        event.preventDefault();

        this.setState({loading: true})

        const {email, message} = this.state.form;

        if (!!email && !!message) {
            await firestore
                .collection("feedback")
                .add({
                    email,
                    message,
                    team: getBasePath(),
                    user: this.props.user.id,
                    createdAt: new Date()
                });
            this.setState({loading: false, sent: true});
        }
    }

    render() {

        if(!this.props.user) return <Loading/>;
        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Provide us with feedback
                        <Loading right loading={this.state.loading} />
                    </h1>
                </div>

                <div className="card-body">
                    {this.state.sent ? (
                        <p>Thank you for your message! We will reply as soon as possible.</p>
                    ) : (
                        <Form onSubmit={this.submitForm.bind(this)}>
                            <FormGroup>
                                <Row>
                                    <Col sm={12}>
                                        <p>Do you have any comments, questions or other feedback? Please don't hesitate to
                                            send us a message.</p>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Reply e-mail address
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl componentClass="input" name="email" value={this.state.form.email} defaultValue={this.props.user.email}
                                                     onChange={this.handleChange.bind(this)}/>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={4} componentClass={ControlLabel}>
                                        Your comment
                                    </Col>
                                    <Col sm={8}>
                                        <FormControl componentClass="textarea" name="message"
                                                     value={this.state.form.message}
                                                     onChange={this.handleChange.bind(this)}/>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={8} smOffset={4}>
                                        <Button bsStyle="primary" type="submit">
                                            <Glyphicon glyph="ok"/>&nbsp;
                                            Send
                                        </Button>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    )}
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    user: state.users.active
}))(FeedbackPage);


// WEBPACK FOOTER //
// ./src/pages/FeedbackPage.js